import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../Context/LanguageContext";
import "./Events.css";

const EVENTS_API_URL =
    "https://script.google.com/macros/s/AKfycbwoNQHZnU5j4Pb8NIwzuVsBg5TBKlKRhYJXsxmCK0J6Rb8QRCf6-ixVudn7-KReaDcu/exec";


function Events() {

    const { language } = useLanguage();

    const [upcoming, setUpcoming] = useState([]);
    const [past, setPast] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {

        const loadEvents = async () => {

            try {

                setLoading(true);
                setError(null);

                const response =
                    await fetch(EVENTS_API_URL);

                if (!response.ok) {
                    throw new Error(
                        "Unable to load events."
                    );
                }

                const data =
                    await response.json();

                setUpcoming(
                    data.upcoming || []
                );

                setPast(
                    data.past || []
                );

            } catch (error) {

                console.error(error);

                setError(error.message);

            } finally {

                setLoading(false);

            }

        };


        loadEvents();

    }, []);


    const formatDate = (date) => {

        if (!date) return "";

        return new Intl.DateTimeFormat(
            language === "bn"
                ? "bn-BD"
                : "en-GB",
            {
                day: "numeric",
                month: "long",
                year: "numeric"
            }
        ).format(
            new Date(`${date}T00:00:00`)
        );

    };


    const getTitle = (event) => {

        return language === "bn"
            ? event.title_bn || event.title_en
            : event.title_en || event.title_bn;

    };


    const getLocation = (event) => {

        return language === "bn"
            ? event.location_bn || event.location_en
            : event.location_en || event.location_bn;

    };


    return (

        <main className="events-page">


            {/* PAGE HEADER */}

            <section className="events-hero">

                <div className="container events-hero-content">

                    <span className="events-hero-label">
                        {language === "bn"
                            ? "আমাদের আয়োজন"
                            : "Our Events"}
                    </span>

                    <h1>
                        {language === "bn"
                            ? "অনুষ্ঠান ও কার্যক্রম"
                            : "Events & Activities"}
                    </h1>

                    <p>
                        {language === "bn"
                            ? "আমরা-আমরার আসন্ন ও বিগত অনুষ্ঠান, সামাজিক কার্যক্রম এবং সাংস্কৃতিক আয়োজন সম্পর্কে জানুন।"
                            : "Explore upcoming and past events, community activities and cultural programs organized by Amra-Amra."}
                    </p>

                </div>

            </section>


            {/* EVENTS CONTENT */}

            <section className="events-content">

                <div className="container">


                    {loading && (

                        <div className="events-status">
                            <div className="events-loader"></div>

                            <p>
                                {language === "bn"
                                    ? "অনুষ্ঠানের তথ্য লোড হচ্ছে..."
                                    : "Loading events..."}
                            </p>
                        </div>

                    )}


                    {!loading && error && (

                        <div className="events-status events-error">

                            <h3>
                                {language === "bn"
                                    ? "তথ্য লোড করা যায়নি"
                                    : "Unable to load events"}
                            </h3>

                            <p>{error}</p>

                        </div>

                    )}


                    {!loading && !error && (

                        <>


                            {/* UPCOMING */}

                            <div className="events-section-heading">

                                <div>

                                    <span>
                                        {language === "bn"
                                            ? "সামনে যা আসছে"
                                            : "What's Coming"}
                                    </span>

                                    <h2>
                                        {language === "bn"
                                            ? "আসন্ন অনুষ্ঠান"
                                            : "Upcoming Events"}
                                    </h2>

                                </div>

                                <div className="events-heading-line"></div>

                            </div>


                            {upcoming.length > 0 ? (

                                <div className="events-grid upcoming-events-grid">

                                    {upcoming.map((event) => (

                                        <EventCard
                                            key={event.id}
                                            event={event}
                                            language={language}
                                            title={getTitle(event)}
                                            location={getLocation(event)}
                                            date={formatDate(event.date)}
                                            upcoming={true}
                                        />

                                    ))}

                                </div>

                            ) : (

                                <div className="events-empty">

                                    <span>○</span>

                                    <h3>
                                        {language === "bn"
                                            ? "এই মুহূর্তে কোনো আসন্ন অনুষ্ঠান নেই"
                                            : "No upcoming events right now"}
                                    </h3>

                                    <p>
                                        {language === "bn"
                                            ? "নতুন অনুষ্ঠানের তথ্য শিগগিরই এখানে প্রকাশ করা হবে।"
                                            : "New event information will appear here when available."}
                                    </p>

                                </div>

                            )}


                            {/* PAST EVENTS */}

                            {past.length > 0 && (

                                <div className="past-events-section">


                                    <div className="events-section-heading">

                                        <div>

                                            <span>
                                                {language === "bn"
                                                    ? "স্মৃতির পাতা"
                                                    : "From Our Community"}
                                            </span>

                                            <h2>
                                                {language === "bn"
                                                    ? "বিগত অনুষ্ঠান"
                                                    : "Past Events"}
                                            </h2>

                                        </div>

                                        <div className="events-heading-line"></div>

                                    </div>


                                    <div className="events-grid">

                                        {past.map((event) => (

                                            <EventCard
                                                key={event.id}
                                                event={event}
                                                language={language}
                                                title={getTitle(event)}
                                                location={getLocation(event)}
                                                date={formatDate(event.date)}
                                                upcoming={false}
                                            />

                                        ))}

                                    </div>

                                </div>

                            )}

                        </>

                    )}

                </div>

            </section>

        </main>

    );

}


/* =========================================================
   EVENT CARD
========================================================= */

function EventCard({
    event,
    language,
    title,
    location,
    date,
    upcoming
}) {

    const detailUrl =
        event.detail_url ||
        `/events/${event.id}`;


    return (

        <article className="event-card">


            <Link
                to={detailUrl}
                className="event-card-image"
            >

                {event.image ? (

                    <img
                        src={event.image}
                        alt={title}
                    />

                ) : (

                    <div className="event-image-placeholder">
                        <span>আমরা-আমরা</span>
                    </div>

                )}


                <span
                    className={
                        upcoming
                            ? "event-status upcoming"
                            : "event-status past"
                    }
                >

                    {upcoming
                        ? language === "bn"
                            ? "আসন্ন"
                            : "Upcoming"
                        : language === "bn"
                            ? "সম্পন্ন"
                            : "Past"}

                </span>

            </Link>


            <div className="event-card-body">


                <div className="event-date">

                    <span className="event-meta-icon">
                        ◷
                    </span>

                    {date}

                </div>


                <h3>

                    <Link to={detailUrl}>
                        {title}
                    </Link>

                </h3>


                {location && (

                    <div className="event-location">

                        <span className="event-meta-icon">
                            ●
                        </span>

                        <span>
                            {location}
                        </span>

                    </div>

                )}


                <div className="event-card-footer">

                    <Link
                        to={detailUrl}
                        className="event-details-link"
                    >

                        {language === "bn"
                            ? "বিস্তারিত দেখুন"
                            : "View Details"}

                        <span>→</span>

                    </Link>

                </div>

            </div>

        </article>

    );

}


export default Events;